<template>
  <div>
    <top-bar heading="Assignment"></top-bar>
    <div class="container-fluid p-3">
      <h3>{{ form.name }}</h3>
      <b-card header="Submission History">
        <b-card-body>
          <loading-spinner :loading="!submissions.loaded"></loading-spinner>
          <div v-if="submissions.loaded">
            <div v-if="submissions.data.length === 0" class="text-center">
              <p>(This assignment has not yet been submitted)</p>
            </div>
            <div v-if="submissions.data.length !== 0">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Submitted Date</th>
                    <th>Status</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="submission in submissions.data" :key="submission.id">
                    <td>{{ submission.created_at | moment('calendar') }}</td>
                    <td v-if="submission.grade_status === 0"><span class="badge badge-danger p-2">Unsatisfactory</span></td>
                    <td v-if="submission.grade_status === 1"><span class="badge badge-success p-2">Satisfactory</span></td>
                    <td v-if="submission.grade_status === 2"><span class="badge badge-info p-2">Pending Grading</span></td>
                    <td>
                      <router-link :to="'/submissions/' + submission.id" class="btn btn-primary">View Submission</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-card-body>
      </b-card>

      <b-card header="Assignment">
        <b-card-body class="p-3 offset-1 col-10">
          <div v-if="form.loaded && form.hasCompletedSubmissions" class="text-center">
            <h3>You have already been marked as satisfactory for this assignment!</h3>
          </div>
          <div v-else-if="form.loaded && form.hasPendingSubmissions" class="text-center">
            <h3>You have already have a pending assignment awaiting grading!</h3>
          </div>
          <template v-else>
            <div v-if="form.loaded && !form.submitted">
              <form-viewer :schema="form.schema" v-model="form.data" :form-id="form.id" :on-submit="submitForm"></form-viewer>
            </div>
            <loading-spinner :loading="!form.loaded"></loading-spinner>
            <div v-if="form.submitted" class="text-center">
              <h3>Your assignment has been submitted!</h3>
            </div>
          </template>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import Submissions from '../../mixins/Submissions';
import FormViewer from '../../components/FormViewer/FormViewer';

export default {
  name: 'FormsAssignment',
  components: {FormViewer},
  data () {
    return {
      form: {
        schema: {
          id: 0,
          name: 'Loading..'
        },
        data: {},
        loaded: false
      },
      submissions: {
        data: [],
        loaded: false
      }
    };
  },
  mixins: [Submissions],
  methods: {
    loadSubmissions () {
      this.axios.get('/submissions', {params: {form_id: this.id, user_id: this.$auth.user().id, columns: 'id,form_name,grade_status,created_at', order_by: 'created_at,desc'}}).then(rsp => {
        this.submissions.data = rsp.data.data;
        this.submissions.loaded = true;
      });
    }
  },
  mounted () {
    this.loadForm(this.id);
    this.loadSubmissions();
  },
  metaInfo: {
    title: 'Assignment'
  },
  props: ['id']
};
</script>
